import { useState } from "react";
import { Link, useNavigate, useOutletContext } from "react-router-dom";
import { useClientPortalAuth } from "../../context/ClientPortalAuthContext";
import { formatApiError } from "../../utils/formatApiError";

export default function PortalLogin() {
  const { salonId } = useOutletContext();
  const navigate = useNavigate();
  const { clientLogin, loading } = useClientPortalAuth();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");
    try {
      await clientLogin({ username, password });
      navigate(`/portal/salon/${salonId}/book`, { replace: true });
    } catch (err) {
      const detail = err?.response?.data?.detail;
      if (detail === "INVALID_CREDENTIALS") {
        setError("Invalid username or password.");
      } else {
        setError(formatApiError(err));
      }
    }
  };

  return (
    <div className="max-w-2xl">
      <div className="rounded-2xl border border-slate-200 bg-white p-6">
        <div className="flex items-start justify-between gap-3">
          <div>
            <h2 className="text-xl md:text-2xl font-semibold text-slate-900">
              Welcome back
            </h2>
            <p className="mt-1 text-sm md:text-base text-slate-600">
              Sign in to manage your profile and bookings.
            </p>
          </div>
          <Link
            to={`/portal/salon/${salonId}/register`}
            className="text-sm font-semibold text-slate-700 hover:text-slate-900"
          >
            Need an account?
          </Link>
        </div>

        {error && (
          <div className="mt-4 rounded-2xl border border-rose-200 bg-rose-50 px-4 py-3 text-sm text-rose-700">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="mt-6 space-y-4">
          <div className="space-y-2">
            <label className="text-sm font-semibold text-slate-600">
              Username
            </label>
            <input
              type="text"
              value={username}
              onChange={(event) => setUsername(event.target.value)}
              className="h-11 w-full rounded-xl border border-slate-300 px-4"
              required
            />
          </div>
          <div className="space-y-2">
            <label className="text-sm font-semibold text-slate-600">
              Password
            </label>
            <input
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              className="h-11 w-full rounded-xl border border-slate-300 px-4"
              required
            />
          </div>
          <div className="text-sm">
            <Link
              to={`/portal/salon/${salonId}/forgot-password`}
              className="font-semibold text-slate-700 hover:text-slate-900"
            >
              Forgot password?
            </Link>
          </div>

          <div className="flex items-center gap-3">
            <button
              type="submit"
              disabled={loading}
              className="rounded-full bg-slate-900 px-5 py-2 text-sm md:text-base font-semibold text-white hover:bg-slate-800 disabled:opacity-60"
            >
              {loading ? "Signing in..." : "Login"}
            </button>
            <Link
              to={`/portal/salon/${salonId}`}
              className="rounded-full border border-slate-300 px-5 py-2 text-sm md:text-base font-semibold text-slate-700 hover:bg-slate-50"
            >
              Back to portal
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}
